import { login, loginFail, logout, updateUser } from '../effects/user';
import { DEFECT_KEY } from '../defect';
import { handleEffects } from '../utils/store';

const notConnectedUser = { [DEFECT_KEY]: 'Not connected' };

export default handleEffects(
  {
    [login]: (state, action) => ({ ...action.payload }),
    [logout]: () => notConnectedUser,
    [loginFail]: (state, action) => {
      if (action.payload.error === 'Unauthorized')
        return { ...notConnectedUser, message: 'Access not granted' };
      return { ...notConnectedUser, message: 'Unexpected error' };
    },
    [updateUser]: (state, action) => ({ ...state, ...action.payload }),
  },
  notConnectedUser,
);
